import { gql } from '@apollo/client';

export const deleteFacilityNotepadEntry = gql`
  mutation deleteFacilityNotepadEntry($id: String!) {
    deleteFacilityNotepadEntry(id: $id) {
      value
    }
  }
`;
